import styled from 'styled-components';
import Fab from '@material-ui/core/Fab';
import Grid from '@material-ui/core/Grid';

type Props = { $withLine?: boolean; $stepVisited?: boolean };

const WizardFab = styled(Fab)<Props>`
  ${({ theme, $withLine: withLine, $stepVisited: stepVisited }) => `
    margin-right: ${theme.spacing(1)}px;
    position: relative;
    z-index: 3;
    transition: all .3s ease;
    &:hover: {
      transform: scale(1.1);
      background-color: ${theme.palette.primary.main};
    }
    ${
      withLine &&
      `
        &::after {
          content: '';
          position: absolute;
          z-index: 0;
          bottom: -48px;
          width: 2px;
          height: 48px;
          background-color: ${theme.palette.grey[300]};
          transition: all 0.3s ease;
        }
        &:hover {
          &::after {
            z-index: 0;
            transform: scale(0.9);
            bottom: -44px;
            height: 46px;
          }
        }
      `
    }
    ${stepVisited && `background-color: ${theme.palette.grey[800]};`}
    `}
`;

const WizardGridMenu = styled(Grid)`
  ${({ theme }) => `
    background-color: ${theme.palette.grey[200]};
    border-top-left-radius: ${theme.shape.borderRadius}px;
    border-bottom-left-radius: ${theme.shape.borderRadius}px;
    flex: 1,
    `}
`;

export { WizardGridMenu, WizardFab };
